import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  List,
  ListItem,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../../styles/components/commonAccordian.module.scss";
import assest from "../../../json/assest";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import AdminNoteUpdateModal from "./modals/AdminNoteUpdateModal";
import { useCallback } from "react";
import {
  getUtcDate,
  noteFinder,
  truncateString,
} from "../../../lib/functions/utils.lib";
import { deleteNote } from "../../../api/functions/note.api";
import { useMutation } from "react-query";

const AdminNotes = ({ data, notes, refetchNote }) => {
  const [openCopy, setOpenCopy] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  //   const copyNote = notes.find((note) => note.type == "admin_copywrite");
  const copyNote = noteFinder(notes, "admin_copywrite");
  const editNote = noteFinder(notes, "admin_editor");

  //   console.warn("copyNote", copyNote);
  //   console.warn("editNote", editNote);

  const onCloseCopy = useCallback(() => {
    setOpenCopy(false);
  }, []);
  const onCloseEdit = useCallback(() => {
    setOpenEdit(false);
  }, []);

  const { mutate: mutateDelete } = useMutation(deleteNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
      refetchNote();
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });

  // let st = []

  return (
    <>
      <AdminNoteUpdateModal
        data={data}
        onClose={onCloseCopy}
        open={openCopy}
        refetchNote={refetchNote}
        modalTitle="Leave a note for the Copywriters"
        modalSubject="Is there something you would like to bring to the Copywriter’s attention?"
        addKey="admin_copywrite"
        receiver_role={5}
      />
      <AdminNoteUpdateModal
        data={data}
        onClose={onCloseEdit}
        open={openEdit}
        refetchNote={refetchNote}
        modalTitle="Leave a note for the Editors"
        modalSubject="Is there something you would like to bring to the Editor’s attention?"
        addKey="admin_editor"
        receiver_role={4}
      />
      <Box className={styles.commonAccordianWrapper}>
        {/* <Box> */}
        <Accordion disabled={data.status != 1 ? true : false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>My Notes</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box className={styles.accordianTxt}>
              <Box className={styles.accordianTxtButton}>
                <Accordion expanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Button
                      disabled={copyNote ? true : false}
                      onClick={() => setOpenCopy(true)}
                      className={styles.accordianButtonBox}
                    >
                      <img
                        src={assest.noteIcon}
                        width={19}
                        height={18}
                        alt=""
                      />{" "}
                      {!copyNote && "Leave a"} Note for the Copywriters
                    </Button>
                  </AccordionSummary>
                  {copyNote && (
                    <AccordionDetails>
                      <Box className={styles.expandedAccordianTxt}>
                        <Box className={styles.notesBox}>
                          <p>{truncateString(copyNote.note, 100)}</p>
                          <Box className={styles.notesBoxButton}>
                            <Box className={styles.notesdate}>
                              <Button>
                                <img
                                  src={assest.noteDateIcon}
                                  width={11}
                                  height={11}
                                  alt=""
                                />{" "}
                                <span>{getUtcDate(copyNote.created_at)}</span>
                              </Button>
                            </Box>

                            <Box className={styles.noteDelRead}>
                              <List>
                                <ListItem>
                                  <Box
                                    className={`${styles.notesdate} ${styles.deleteButton}`}
                                  >
                                    <Button
                                      onClick={() => mutateDelete(copyNote.id)}
                                    >
                                      <img
                                        src={assest.noteDeleteIcon}
                                        width={11}
                                        height={12}
                                        alt=""
                                      />{" "}
                                      <span>Delete</span>
                                    </Button>
                                  </Box>
                                </ListItem>
                                <ListItem>
                                  <Box className={styles.notesdate}>
                                    <Button disabled>
                                      <img
                                        src={assest.noteEyeIcon}
                                        width={11}
                                        height={9}
                                        alt=""
                                      />{" "}
                                      <span>Read</span>
                                    </Button>
                                  </Box>
                                </ListItem>
                              </List>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  )}
                </Accordion>
              </Box>
              <Box className={styles.accordianTxtButton}>
                <Accordion expanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Button
                      disabled={editNote ? true : false}
                      onClick={() => setOpenEdit(true)}
                      className={styles.accordianButtonBox}
                    >
                      <img
                        src={assest.noteIcon}
                        width={19}
                        height={18}
                        alt=""
                      />{" "}
                      {!editNote && "Leave a"} Note for the Editors
                    </Button>
                  </AccordionSummary>
                  {editNote && (
                    <AccordionDetails>
                      <Box className={styles.expandedAccordianTxt}>
                        <Box className={styles.notesBox}>
                          <p>{truncateString(editNote.note, 100)}</p>
                          <Box className={styles.notesBoxButton}>
                            <Box className={styles.notesdate}>
                              <Button>
                                <img
                                  src={assest.noteDateIcon}
                                  width={11}
                                  height={11}
                                  alt=""
                                />{" "}
                                <span>{getUtcDate(editNote.created_at)}</span>
                              </Button>
                            </Box>

                            <Box className={styles.noteDelRead}>
                              <List>
                                <ListItem>
                                  <Box
                                    className={`${styles.notesdate} ${styles.deleteButton}`}
                                  >
                                    <Button
                                      onClick={() => mutateDelete(editNote.id)}
                                    >
                                      <img
                                        src={assest.noteDeleteIcon}
                                        width={11}
                                        height={12}
                                        alt=""
                                      />{" "}
                                      <span>Delete</span>
                                    </Button>
                                  </Box>
                                </ListItem>
                                <ListItem>
                                  <Box className={styles.notesdate}>
                                    <Button disabled>
                                      <img
                                        src={assest.noteEyeIcon}
                                        width={11}
                                        height={9}
                                        alt=""
                                      />{" "}
                                      <span>Read</span>
                                    </Button>
                                  </Box>
                                </ListItem>
                              </List>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  )}
                </Accordion>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};

export default AdminNotes;
